import React, { useState } from 'react'
import { Flex } from '@mantine/core'
import { MRT_ColumnDef } from 'mantine-react-table'
import CustomTooltip from 'src/components/CustomComponents/CustomTooltip'
import CategoryTrailsPageList from 'src/containers/CategoryTrails/CategoryTrailsPageList'
import { pathUrl, size } from 'src/variable/constant'
import { useNavigate } from 'react-router-dom'
import { VisibilityOff, CheckCircle } from '@mui/icons-material'

function TopicsPage() {
	const navigate = useNavigate()
	const [openTopic, setOpenTopic] = useState<any>({ open: false, id: null })

	const columns: MRT_ColumnDef[] = [
		{
			accessorKey: 'no',
			header: 'No',
			size: size.zero,
		},
		{
			accessorKey: 'title',
			header: 'Topics',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => {
				return (
					<CustomTooltip label={cell.getValue<string>()} maxWidth={size.text} />
				)
			},
			enableResizing: false,
		},
		{
			accessorKey: 'order',
			header: 'Order',
			size: size.zero,
			maxSize: size.text,
		},
		{
			accessorKey: 'status',
			header: 'Status',
			size: size.zero,
			maxSize: size.text,
			Cell: ({ cell }) => {
				const value = cell.getValue<string>();
				const label = value ? 'Showing' : 'Hidden'
				const Icon = value ? CheckCircle : VisibilityOff
				return (
					<>
						<CustomTooltip label={label}>
							<Icon color={value ? 'success': 'error'} />
						</CustomTooltip>
					</>
				)
			}
		},
		{
			accessorKey: 'created_at',
			header: 'Created at',
			size: size.zero,
			maxSize: size.text,
		},
	]
	const fields = [
		{
			value: 'title',
			label: 'Title',
		},
	]
	const handleEdit = (row: any) => {
		setOpenTopic({ open: true, id: row?.original })
	}
	const handleDetail = (row: any) => {
		navigate(`${pathUrl.topics}/${row?.original?.id}`)
	}
	return (
		<Flex sx={{ width: '100%' }}>
			<CategoryTrailsPageList
				columns={columns}
				fields={fields}
				handleEdit={handleEdit}
				type="TOPIC_DISCUSS"
				openTopic={openTopic}
				setOpenTopic={setOpenTopic}
				handleDetail={handleDetail}
			/>
		</Flex>
	)
}

export default React.memo(TopicsPage)
